import { render, staticRenderFns } from "./AdditionalAbandonedCartReminder.vue?vue&type=template&id=0d447600&scoped=true"
import script from "./AdditionalAbandonedCartReminder.vue?vue&type=script&lang=js"
export * from "./AdditionalAbandonedCartReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d447600",
  null
  
)

export default component.exports